import React from 'react';

const CustomSlide4 = ({className = ''}) => {
    return (
        <section className={`container ps-custom-slide4 ${className}`.trim()} aria-labelledby="ps-custom-slide4-title">
            <div className="ps-custom-slide4__intro">
                <span className="ps-custom-slide4__eyebrow">Our Natural Story</span>
                <h2 id="ps-custom-slide4-title">Goodness, crafted naturally.</h2>
                <span className="ps-custom-slide4__divider" aria-hidden="true">
                    <span />
                    <i className="icon-leaf" />
                    <span />
                </span>
                <p>Take a closer look at the care behind every Nature Way product.</p>
            </div>

            <div className="ps-custom-slide4__videoCard">
                <video
                    className="ps-tap-the-cap__video"
                    src="/assets/img/natural-video.mp4"
                    poster="/assets/img/custom_comp2_image.png"
                    controls
                    playsInline
                    preload="metadata"
                />
            </div>
        </section>
    );
};

export default CustomSlide4;
